interface Props {
  size?: number;
  /** When true, uses the wordmark PNG (icon + "Boletra" lockup). */
  withWordmark?: boolean;
  className?: string;
}

/**
 * Boletra brand mark. Uses the production logo PNGs hosted in `apps/web/public`:
 *   - logo-icon.png (square icon, transparent background)
 *   - logo-full.png (icon + wordmark)
 *
 * The PNGs are pre-cropped to the artwork bounds and have transparent
 * background so they sit cleanly on dark surfaces. The icon variant is
 * height-squared so it can be used as a 1:1 favicon-style mark.
 */
export function BrandMark({ size = 28, withWordmark = false, className }: Props) {
  if (withWordmark) {
    // Native aspect ratio of logo-full.png is roughly 4.45:1.
    return (
      <img
        src="/logo-full.png"
        alt="Boletra"
        width={size * 4.45}
        height={size}
        className={className}
        decoding="async"
      />
    );
  }
  return (
    <img
      src="/logo-icon.png"
      alt="Boletra"
      width={size}
      height={size}
      className={className}
      decoding="async"
    />
  );
}
